import React from 'react';
import { useHistory } from 'react-router-dom';
import { PortalEndpointAside } from 'vet-bones/components/molecules/Portal';

import { useAppDispatch } from 'src/ui/app/hooks';
import {
  PORTAL_ENDPOINT_ASIDE_MANAGE_ENDPOINTS,
  PORTAL_ENDPOINT_ASIDE_SELECTOR,
  PORTAL_ENDPOINT_ASIDE_SELECTOR_ITEM,
} from 'src/ui/constants/testIds';
import { toggledNavbarAside } from 'src/ui/features/ui';
import { graphQLClient } from 'src/ui/graph/graphQLClient';
import { useSavedConnectionsQuery } from 'src/ui/graph/types';
import {
  useCurrentConnection,
  useNavigateToConnection,
} from 'src/ui/hooks/connection';
import {
  useLandingConnectionIdx,
  useOrgDomain,
} from 'src/ui/hooks/navbar/connection';
import { useIsOrganizationAdmin } from 'src/ui/hooks/organization';
import * as copy from 'src/ui/templates/copy';

export const PortalEndpointAsideWrapper: React.VFC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const org = useOrgDomain();
  const isOrgAdmin = useIsOrganizationAdmin(org);
  const connectionIdx = useLandingConnectionIdx();
  const { connection: connectionFallback } = useCurrentConnection(
    connectionIdx,
    org
  );

  const { data: savedConnectionsData } = useSavedConnectionsQuery(
    graphQLClient,
    { org_domain: org }
  );
  const connection =
    savedConnectionsData?.listConnections?.find(
      (connection) => connection?.index.toString() === connectionIdx
    ) ||
    // fallback to direct call to include connections not found in list (like the demo connection)
    connectionFallback;

  const navigateToConnection = useNavigateToConnection(org);

  return (
    <PortalEndpointAside
      connectionInfo={
        connection?.index !== undefined
          ? { connectionIndex: connection.index }
          : undefined
      }
      copy={copy.components.navbar.aside.portalEndpoint}
      onManageEndpoints={
        !org || isOrgAdmin
          ? () => {
              history.push(org ? `/o/${org}/connections` : '/connections');
            }
          : undefined
      }
      onSelectConnection={(connectionItem) => {
        navigateToConnection(connectionItem.index);
        dispatch(toggledNavbarAside({ isAsideOpen: false }));
      }}
      testIds={{
        manageEndpoints: PORTAL_ENDPOINT_ASIDE_MANAGE_ENDPOINTS,
        selector: PORTAL_ENDPOINT_ASIDE_SELECTOR,
        selectorItem: PORTAL_ENDPOINT_ASIDE_SELECTOR_ITEM,
      }}
    />
  );
};
